import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import MobileView from './layouts/MobileView'
import DesktopView from './layouts/DesktopView'
import useMenuData from './utils/useMenuData'

const Navbar = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])
  const isMobile = 860 >= screenWidth

  const { pathname } = useLocation()
  const [bookToday, setBookToday] = useState(false)

  //SECTION - Goes to the top of the page (or to the contact page)
  useEffect(() => {
    if (bookToday && pathname === '/') {
      const contactSection = document.querySelector('#contact');
      if (contactSection) {
        contactSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
      setBookToday(false)
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname])

  useEffect(() => {
    if (bookToday && pathname === '/') {
      const contactSection = document.querySelector('#contact');
      if (contactSection) {
        contactSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
      setBookToday(false)
    }
  }, [bookToday])

  return (
    <>
      <div className='h-[90px]'></div>
      <div className='flex h-[90px] z-[11] fixed w-full bg-emerald-50 items-center justify-between lg:justify-center px-[20px]'>
        {isMobile ? (
          <MobileView />
        ) : (
          <DesktopView setBookToday={setBookToday} />
        )}
      </div>
    </>
  )
}

export default Navbar
